module.exports = __webpack_public_path__ + "img/1f624.0760a65.svg";